import { IUserPlanPreferences } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import {
  EMPTY_MARKET_SEGMENT_SELECTION,
  IMarketSegmentSelection,
} from '@creditflowresearch/user-plan/vo/IMarketSegmentSelection';

class Preferences {
  private readonly productIds: string[];

  private readonly regionIds: string[];

  private readonly marketIds: string[];

  private readonly marketSegments: IMarketSegmentSelection;

  constructor(preferences: IUserPlanPreferences) {
    this.productIds = preferences.productIds || [];
    this.regionIds = preferences.regionIds || [];
    this.marketIds = preferences.marketIds || [];
    this.marketSegments = preferences.marketSegments || EMPTY_MARKET_SEGMENT_SELECTION;
  }

  getProductIds(): string[] {
    return [...this.productIds];
  }

  getRegionIds(): string[] {
    return [...this.regionIds];
  }

  getMarketIds(): string[] {
    return [...this.marketIds];
  }

  /** The segments saved for one row — a corporate product id, or the EM market id. */
  getMarketSegmentIds(scopeId: string): string[] {
    const group = this.marketSegments.groups.find(({ id }) => id === scopeId);

    return [...(group?.marketSegmentIds ?? [])];
  }
}

export default Preferences;
